import Handsontable from 'handsontable'
import {mapInternalStatusToColor, orderPriorityColors} from "./Settings"
import moment from "moment";
import {Constants, internalStatus, pickupProcessInternalStatuses} from "../../Constants/Constant";
import store from '../../store';
import router from "../../router";

export function actionRenderer(instance, td, row, col, prop, value, cellProperties, self, screen) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let v = instance.getDataAtRowProp(row, 'internalStatusId');                               //prop name 'internalStatus'
    let lastStageUpdatedOn = instance.getDataAtRowProp(row, 'lastStageUpdatedOn');                       //prop name 'lastStageUpdatedOn'
    td.innerHTML = value
    td.style.background = mapInternalStatusToColor[v][0]
    if(mapInternalStatusToColor[v][1]){
      td.style.color = mapInternalStatusToColor[v][1]
    }

    if(value === 'Completed') return

    let ordersVariable = screen + '_orders'
    let pRow = instance.toPhysicalRow(row)                               //When accessing original array
    let order = self[ordersVariable][pRow]
   /* ------ For Cancel Orders ------------- */
    if(order.materials.boxes === 'Empty Return Charge'){
      td.style.borderLeft = `6px solid red`
    }
    /* ---------x-----------x----------x---- */
    // console.log('row renderer ' + screen, row)
   /* ---- Important Clear Interval previously set ---- */
    if(self.elapsedInterval[screen][order.id]){                                  //Check what comes.. row or pRow
      clearInterval(self.elapsedInterval[screen][order.id])
    }
   /* --------x----------x----------x---------x--------- */

  if(lastStageUpdatedOn){
    let date = moment(lastStageUpdatedOn).format('DD/MM/YYYY HH:mm:ss')
    let elapsedTime = moment().unix() - moment(date, 'DD/MM/YYYY HH:mm:ss').unix()
    td.innerHTML = value + '<br>' + '-'
    self.elapsedInterval[screen][order.id] = setInterval( () => {
      elapsedTime++

      let days = Math.floor(elapsedTime / 86400);

      let hours = Math.floor(elapsedTime / 3600) % 24;

      let minutes = Math.floor(elapsedTime / 60) % 60;
      // let seconds = elapsedTime - minutes * 60;

      hours = hours.toString().length === 1 ? ('0' + hours) : hours
      minutes = minutes.toString().length === 1 ? ('0' + minutes) : minutes
      td.innerHTML = value + '<br><span>' + days + 'd ' + hours + ':'+ minutes+'</span>'
      if(mapInternalStatusToColor[v][1]) td.children[1].style.color = mapInternalStatusToColor[v][1]
    }, 1000)
  }
}
export function statusRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let internalStatus = instance.getDataAtRowProp(row, 'internalStatus')                               //prop name 'internalStatus'
  td.innerHTML = internalStatus
  td.style.background = mapInternalStatusToColor[value][0]
  if (mapInternalStatusToColor[value][1]) {
    td.style.color = mapInternalStatusToColor[value][1]
  }
}
export function orderNumberRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let priority = instance.getDataAtRowProp(row, 'priority')                               //prop name 'priority'

  td.innerHTML = '<span>'+value.substring(0, 3)+'</span>' +'<span>'+value.substring(3, 9)+'</span><br>' +
    '<span>'+value.substring(9, 11)+'</span>'+'<span>' + value.substring(11, value.length) + '</span>'

  if(orderPriorityColors[priority]){
    // td.style.color = orderPriorityColors[priority]
    td.children[0].style.color = orderPriorityColors[priority][0]
    td.children[1].style.color = orderPriorityColors[priority][1]
    td.children[3].style.color = orderPriorityColors[priority][1]
    td.children[4].style.color = orderPriorityColors[priority][0]
  }
  td.classList.add('order-num-txt')
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let ordersVariable = array || self.screen + '_orders'                    //array as variable-name 'orders'

  let order = self[ordersVariable][pRow]
  td.onclick = () => {
    self.editOrder(order)
  }
}
export function pickupAreaGroupRenderer(instance, td, row, col, prop, value, cellProperties, self) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let ordersVariable = self.screen + '_orders'
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let order = self[ordersVariable][pRow];
  let pickupPartyName = order.obj.pickupPartyName;
  td.innerHTML = `${pickupPartyName}<br><span class="area-group-text">( ${value} )</span>`
  if(cellProperties.readOnly) td.classList.add('cell-readonly')
}
export function dropAreaGroupRenderer(instance, td, row, col, prop, value, cellProperties, self) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let ordersVariable = self.screen + '_orders'
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let order = self[ordersVariable][pRow]
  let mappedAreas = store.state.mappedAreas
  let dropAreaGroup = order.orderDetails.dropPoint.area ? mappedAreas[order.orderDetails.dropPoint.area.toLowerCase()]||'' : mappedAreas[order.droppingpartyobject.address[0].area.toLowerCase()]||''
  td.innerHTML = `${value}<br><span class="area-group-text">( ${dropAreaGroup} )</span>`
  if(cellProperties.readOnly) td.classList.add('cell-readonly')
}
export function orderDetailsRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let ordersVariable = array || self.screen + '_orders'

  let order = self[ordersVariable][pRow]
  let type = order?.materials?.type
  let weight = order?.materials?.kg
  let size = order?.orderDetails?.materialSize

  td.innerHTML = '<span style="color: gray">' + type + '</span>'+ '<br>' + value
  td.style.verticalAlign = 'middle'
  td.style.textAlign = 'center'
  td.style.borderLeft = `6px solid ${MaterialVehicleColor(weight, size)}`
}
export function noteRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);

}
export function lrNumberRenderer(instance, td, row, col, prop, value, cellProperties, self, screen) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  let ordersVariable = screen + '_orders'
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let order = self[ordersVariable][pRow]

  if(!cellProperties.readOnly){
    let div = document.createElement('div');
    div.classList.add('order-num-txt')
    div.innerHTML = 'Add LR'
    div.onclick = () => { self.addLR(order) }
    td.appendChild(div)
  }
  order.LRs.forEach(lr => {
      let div = document.createElement('div');
      div.classList.add('order-num-txt')
      div.innerHTML = lr.lrNumber
      div.onclick = () => { self.editLR(order, lr) }
      td.appendChild(div)
  })

  /* Show LR for every stage if any but edit permission as per permission */
}
export function createdUpdatedOnRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.innerHTML = value.substring(0, 10) + '<br>' + value.substring(10, value.length)
}
export function carryBillRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    if(value === null){

    }else if(value === false){
        td.innerHTML = '<i class="fas fa-times-circle" style="font-size: 22px;color: red"></i>'
    }else {
        td.innerHTML = '<i class="fas fa-check-circle" style="font-size: 22px;color: green"></i>'
    }
}
export function ewayBillRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let ordersVariable = array || self.screen + '_orders'
    let pRow = instance.toPhysicalRow(row)                               //When accessing original array
    let order = self[ordersVariable][pRow]
  if(order.orderDetails?.isEwayBillVerified){
    td.classList.add('green-text')
  }else{
    td.classList.add('red-text')
  }
}
export function localVehicleRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let ordersVariable = array || self.screen + '_orders'
    let pRow = instance.toPhysicalRow(row)                               //When accessing original array
    let order = self[ordersVariable][pRow], tempoOrderId = null;
  if(order.orderDetails?.PIckupTempo){
    td.innerHTML = '<span>'+value+'</span><br><span style="color: #999999">'+order.orderDetails.PIckupTempo.driverDetail.name+'</span>'
    tempoOrderId = order.orderDetails.PIckupTempo.id
  }else if(order.orderDetails?.PickupTruck){
    td.innerHTML = '<span>'+value+'</span><br><span style="color: #999999">'+order.orderDetails.PickupTruck.driverDetail.name+'</span>'
    tempoOrderId = order.orderDetails.PickupTruck.id
  }else{
    td.innerHTML = '<i class="fas fa-plus-circle" style="font-size: 24px; color: #c3c3c3;"></i>'
  }
  /* To Prevent single click when dblclick */
  if(tempoOrderId){
    let clickCount = 0, singleClickTimer, path;
    td.onclick = () => {                           //Using addEventListener keeps adding new event instead overwriting
      clickCount++;
      if(clickCount === 1) {
       path =  order.orderDetails.PIckupTempo ? '/excel-tempo-orders/' : '/excel-truck-orders/';
       singleClickTimer = setTimeout(() => { clickCount = 0; router.push({path: path + tempoOrderId})},400);
      } else if(clickCount === 2) { clearTimeout(singleClickTimer); clickCount = 0 }
    }
    td.classList.add('order-num-txt')
  } else{
    td.onclick = null        //**Important - To override previous click event
  }
  /* -----x--------x----------x--------- */
}
export function transportVehicleRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let ordersVariable = array || self.screen + '_orders'
    let pRow = instance.toPhysicalRow(row)                               //When accessing original array
    let order = self[ordersVariable][pRow]
  /* To Prevent single click when dblclick */
    if(order.orderDetails?.truckOrder){
      td.innerHTML = '<span>'+value+'</span><br><span style="color: #999999">'+order.orderDetails.truckOrder.driverDetail.name+'</span>'
      let clickCount = 0, singleClickTimer;
      td.onclick = () => {
        clickCount++;
        if(clickCount === 1) {
          singleClickTimer = setTimeout(() => { clickCount = 0; router.push({ path: '/excel-truck-orders/'+order.orderDetails.truckOrder.id}) },400);
        } else if(clickCount === 2) { clearTimeout(singleClickTimer); clickCount = 0 }
      }
      td.classList.add('order-num-txt')
    }else{
      td.onclick = null          //**Important - To override previous click event
      td.innerHTML = '<i class="fas fa-plus-circle" style="font-size: 24px; color: #c3c3c3;"></i>'
    }
  /* -----x--------x----------x--------- */
}
export function clientNameRenderer(instance, td, row, col, prop, value, cellProperties, self, screen) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  let ordersVariable = screen + '_orders'
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let order = self[ordersVariable][pRow]
  let commentEle = document.getElementsByClassName('comments')[0]

  td.onmouseover = () => {
    let position = td.getBoundingClientRect()
    let left = position.x + position.width
    let top = position.y

    commentEle.childNodes[1].innerHTML = self.getCompanyDetailString(order.clientobject)      //Access textArea element
    commentEle.style.top = top + 'px'
    commentEle.style.left = left + 'px'
    commentEle.style.display = 'block'
  }
  td.onmouseout = () => {
    commentEle.style.display = 'none'
  }
}

export function pickupDateRenderer(instance, td, row, col, prop, value, cellProperties, self) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let ordersVariable = self.screen + '_orders'
  let pRow = instance.toPhysicalRow(row)                               //When accessing original array
  let order = self[ordersVariable][pRow]
  if(pickupProcessInternalStatuses.includes(order.internalstatus)&&
     moment().format('YYYY-MM-DD')>moment(order.pickupDate).format('YYYY-MM-DD'))
    td.classList.add('red-bold-text')
}

export function getAddressString(a){
  let str = ''
  // let a = obj.address[0]
  if(a?.add1) str = str + a.add1 + ', '
  if(a?.add2) str = str + a.add2 + ', '
  if(a?.area) str = str + a.area + ', '
  if(a?.city) str = str + a.city + ', '
  if(a?.state) str = str + a.state
  if(a?.pincode) str = str + ' - ' + a.pincode
  return str
}
const vehicleColorCode = {
  'auto' : '#c2bebb',
  'chotaHati' : '#a7d08d',
  'chhakdo' : '#f9d85c',
  'pickup' : '#c55911',
  '407' : '#6f2ea8',
  'default': '#ecd9ba'
}
 export function MaterialVehicleColor(weight, size){
    let color = vehicleColorCode.default;
    if(!size || !weight) color = 'unset';
    else if(weight <= 500 && ['small', 'medium'].includes(size)) color = vehicleColorCode.auto;
    else if(weight <= 500 && ['big'].includes(size)) color = vehicleColorCode.chotaHati;
    else if(weight > 500 && weight <= 1500 && ['small', 'medium'].includes(size)) color = vehicleColorCode.chhakdo;
    else if(weight > 500 && weight <= 1500 && ['big'].includes(size)) color = vehicleColorCode.chotaHati;
    else if(weight > 1500 && weight <= 2000 && ['small', 'medium'].includes(size)) color = vehicleColorCode.chotaHati;
    else if(weight > 1500 && weight <= 2000 && ['big'].includes(size)) color = vehicleColorCode.chotaHati;
    else if(weight > 2000  && weight <= 3000 && ['small', 'medium'].includes(size)) color = vehicleColorCode.pickup;
    else if(weight > 2000 && weight <= 3000 && ['big'].includes(size)) color = vehicleColorCode.pickup;
    else if(weight > 3000 && weight <= 5000 && ['small', 'medium'].includes(size)) color = vehicleColorCode['407'];
    else if(weight > 3000 && weight <= 5000 && ['big'].includes(size)) color = vehicleColorCode['407'];
    return color
 }
